import {
  FETCH_PROJECT_FILES,
  SET_PROJECT_FILES_ERROR_MESSAGES,
} from "../actions/types";

var initialState = {
  items: [],
  errorMessages: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROJECT_FILES:
      return {
        ...state,
        items: action.payload,
      };
    case SET_PROJECT_FILES_ERROR_MESSAGES:
      return {
        ...state,
        errorMessages: action.payload,
      };
    default:
      return state;
  }
};
